module.exports = __webpack_public_path__ + "static/media/EndocardialSegmentation_1-950w.c14add2f.jpg";